import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleAuthProvider, signInWithPopup, onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase/firebaseConfig';
import './LoginPage.css';

const provider = new GoogleAuthProvider();

export default function LoginPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [inactivityNotice, setInactivityNotice] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem('signedOutReason') === 'inactivity') {
      sessionStorage.removeItem('signedOutReason');
      setInactivityNotice(true);
    }
    const unsub = onAuthStateChanged(auth, (user) => {
      if (user) navigate('/dashboard', { replace: true });
    });
    return unsub;
  }, [navigate]);

  const handleGoogleSignIn = async () => {
    setLoading(true);
    setError(null);
    try {
      await signInWithPopup(auth, provider);
      // onAuthStateChanged will navigate automatically
    } catch (err) {
      if (err.code !== 'auth/popup-closed-by-user') {
        setError('Sign-in failed. Please try again.');
      }
      setLoading(false);
    }
  };

  return (
    <div className="login-root">
      <div className="login-card">
        {/* Logo */}
        <img src="/logo.png" alt="Team Fronx" className="login-logo-img" />
        <h1 className="login-title">Team Fronx</h1>
        <p className="login-subtitle">Admin Portal</p>
        <p className="login-desc">
          Sign in with your authorised Google account to manage members and events.
        </p>

        {inactivityNotice && (
          <div
            className="login-error"
            style={{
              background: 'rgba(212, 181, 116, 0.12)',
              borderColor: 'rgba(212, 181, 116, 0.4)',
              color: '#D4B574',
            }}
          >
            You were signed out due to inactivity. Sign in again to continue.
          </div>
        )}
        {error && <div className="login-error">{error}</div>}

        <button
          className="login-google-btn"
          onClick={handleGoogleSignIn}
          disabled={loading}
        >
          {loading ? (
            <span className="tf-spinner tf-spinner--sm" />
          ) : (
            <GoogleIcon />
          )}
          {loading ? 'Signing in…' : 'Continue with Google'}
        </button>

        <p className="login-footnote">
          Access is restricted to registered admins only.
        </p>

        {/* Developed by Vortixa */}
        <div className="login-devby">
          <span className="login-devby-label">Developed by</span>
          <img src="/vortixa.png" alt="Vortixa" className="login-devby-logo" />
        </div>
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4"/>
      <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 009 18z" fill="#34A853"/>
      <path d="M3.964 10.71A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 000 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
      <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 00.957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
    </svg>
  );
}
